import React from "react";
import NavBar from "../NavBar";
import CardRender from "../DashboardCardRender";
import DashboardTablesRender from "../DashboardTablesRender";
import { DropShipCardData } from "../Dashboard card data";
import {
  INVENTORYDBInOutTableData,
  INVENTORYDBSupplierTableData,
} from "../DashboardTablesData";
import TopProducts from "../TopProducts";
import StackedBarChart from "../StackedBarChart";
import DoubleLineChart from "../DoubleLineChart";
import SingleRefLineChart from "../SingleRefLineChart";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DotsComponent from "../DotsComponent";
import DSTable1 from "./components/DSTable1";
import DSTable2 from "./components/DSTable2";
import { DropShippingColorData } from "../BarColorData";
import { DropShippingBarData } from "../BarchartData";
import PieCardRender from "../PieCardRender";
import { CarCrash } from "@mui/icons-material";
import GraphLabel3 from "../Components/GraphLabel3";

export default function DropshippingDashboard() {
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Dropshipping </span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Dashboard</h1>
        <div id="Right-content-Down-Filters">
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="right-content-cards">
        <CardRender comp={DropShipCardData.slice(0,1)} />
        <PieCardRender data={DropShipCardData[1]} filling={fillingData1} pieColor={PIECOLORS1} pieIndicator={pieIndicator1}/>
        <PieCardRender data={DropShipCardData[2]} filling={fillingData2} pieColor={PIECOLORS2} pieIndicator={pieIndicator2}/>
        <PieCardRender data={DropShipCardData[3]} filling={fillingData3} pieColor={PIECOLORS3} pieIndicator={pieIndicator3}/>
        <CardRender comp={DropShipCardData.slice(4,6)} />
      </div>
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
          <DotsComponent/>
          <DoubleLineChart />
        </div>
        <div className="dashboard-graph">
            <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">SUPPLIER BY LOCATION</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel3 color={["#394A7E","#4E6DCB", "#20BF55"]} 
            value={['Haryana', 'Delhi','Mumbai']}
          />
          <StackedBarChart BarData={DropShippingBarData} ColorData={DropShippingColorData}/>
        </div>
      </div>

      {/* Here I rendered the dashboard table1 */}

      {/* <DashboardTablesRender table1Name={INVENTORYDBSupplierTableData} /> */}
      <DSTable1/>
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
          <TopProducts />
        </div>
        <div className="dashboard-graph">
          <SingleRefLineChart />
        </div>
      </div>
      {/* <DashboardTablesRender table1Name={INVENTORYDBInOutTableData} /> */}
      <DSTable2/>
    </>
  );
}
const fillingData1 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 1050 },
  { name: "Group C", value: 400 },

];
const PIECOLORS1 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator1 = ["#ECECEC","#FFC700", "#F7762E","#FFE754"]

const fillingData2 = [
  { name: "Group A", value: 13 },
  { name: "Group B", value: 87 },

];
const PIECOLORS2 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator2 = ["#F7762E","#FFC700", ]

const fillingData3 = [
  { name: "Group A", value: 600 },
  { name: "Group B", value: 850 },
  { name: "Group C", value: 400 },

];
const PIECOLORS3 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator3 = ["#ECECEC","#FFC700", "#F7762E","#FFE754"]